import React, { Component } from 'react';
import './App.css';
import ToDoList from './components/ToDoList';
import AddToDo from './components/AddToDo';
import styled from 'styled-components'


const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #B0B3BE;
  border: 1px solid gray;
  padding: 20px 5px;
  margin: 0 auto;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px){
    width: 100%;
    height: 100%;
  }

  @media (min-width: 769px){
    width: 50%;
    height: 75%;
  }
    
`;

class App extends Component{
 state = {
  todos: [
    {
      id: 1,
      text: "Drinking 2l of water",
      completed: false
    },
    {
      id: 2,
      text: "Cleaning up my bedroom",
      completed: false
    },
    {
      id: 3,
      text: "Studying english",
      completed: false
    }
  ]
 }

//Togggle Completed

completedToggle = ( id ) => {
  this.setState({todos: this.state.todos.map((todo) => {
if(todo.id === id){
      todo.completed = !todo.completed;
    }
    return todo;
}
)} );}
    
//Delete Item

deleteItem = ( id ) => {
  this.setState(
    {todos: this.state.todos.filter((todo) => todo.id !== id)}
  );

}

//Add Item

addItem = (text) => {
  const todos = this.state.todos;
  const sameToDo = (todos.filter((todo) => todo.text === text)).length !== 0;
  if(sameToDo){
    alert("This task already exists.");
    }else{
      if(text === undefined || text === ""){
      alert("Please enter task text.")
        }else {
          if(text.length > 25){
            alert("The task is too long.")
          }else{
      todos.push({
        id: todos.length + 1,
        text: text,
        completed: false
      });

      this.setState({todos: todos});
    }
   
  }
};

}

 render(){
  return (
  <Wrapper>
  <h1 className="header">To Do</h1>
  <ToDoList 
  toDos={this.state.todos} 
  completedToggle={this.completedToggle} 
  deleteItem={this.deleteItem} />
  <AddToDo add={this.addItem} />
  </Wrapper>
  );
   
 }

}

export default App;
